import { useResourceStore } from "@/stores/models/resourceCenter";

export default async function resourceExists({ to }) {
    let exists = false;
    let rId = to.params.resourceId;
    if (rId) {
        try {
            const resourceStore = useResourceStore();
            let existing = resourceStore.item(rId);

            if (!existing || !existing?.related?.attachments) {
                await resourceStore.fetchItem({
                    key: "VIEW_RESOURCE",
                    query: { id: rId }
                });
            }

            exists = true;
        } catch (err) {
            exists = false;
        }
    }

    if (!exists) {
        return {
            name: "Not Found"
        };
    }
}
